module.exports = __webpack_public_path__ + "media/images/wrong-0627ad16c2804912b39700eadd80cb9f.svg";